import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function oneDigitCharacterValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regex = new RegExp('^(?=.*[0-9]).+$');
    const isValid = regex.test(control.value);
    return isValid ? null : { oneDigitCharacter: { value: control.value } };
  };
}
